import { getUserColor } from '@/core/lib/get-user-color';

/** Fallback bar color for a task with no assignee. */
const DEFAULT_BAR_COLOR = '#94a3b8';

/**
 * Resolves the color of a task bar in the Timeline view. Isolated as the single
 * seam for this decision — the bar is colored by the task's assignee, the same
 * `getUserColor` source the avatar itself uses (matching the Activity view's
 * actor-color convention), so a bar and its row's avatar always agree.
 */
export function resolveTimelineBarColor(assigneeId: string | null | undefined): string {
  return assigneeId ? getUserColor(assigneeId) : DEFAULT_BAR_COLOR;
}
